import React from 'react';
import { useTheme } from '../../../../../../../theme';
import { FareFeaturePaymentType } from '@websky/graphql';
import cn from 'classnames';
import { WithTooltip } from '@shared/ui/';
const ListOption = ({ className, title, optionIcon, paymentIcon, paymentType, optionType, param, tooltip }) => {
    const { ListOption: css } = useTheme('Entities').FareGroupV2;
    return (React.createElement("div", { "data-option-type": optionType, className: cn(css.root, className, {
            [css.pay]: paymentType === FareFeaturePaymentType.Pay,
            [css.free]: paymentType === FareFeaturePaymentType.Free,
            [css.notAvailable]: paymentType === FareFeaturePaymentType.NotAvailable,
            [css.withTooltip]: !!tooltip
        }) },
        React.createElement("div", { className: css.left },
            !!optionIcon && React.createElement("div", { className: css.optionIcon }, optionIcon),
            !!title && React.createElement("div", { className: css.title }, title)),
        React.createElement(WithTooltip, { title: tooltip, enterTouchDelay: 0 },
            React.createElement("div", { className: css.right },
                !!param && React.createElement("div", { className: css.param }, param),
                !!paymentIcon && React.createElement("div", { className: css.paymentIcon }, paymentIcon)))));
};
export default ListOption;
